<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 v-if="!isEdit" class="text-center">Add Pass</h2>
      <h2 v-if="isEdit" class="text-center">Edit Pass</h2>
    </div>
    <div class="row">
      <div class="col-md-12">
        <card>
          <!-- <h5 slot="header" v-if="!isEdit" class="title">New Restaurant</h5>
          <h5 slot="header" v-if="isEdit" class="title">Edit Restaurant</h5>-->
          <form>
            <div class="row">
              <div class="col-md-6">
                <base-input
                  type="text"
                  label="Name *"
                  maxlength="50"
                  placeholder="Name"
                  v-model="pass_name"
                >
                </base-input>
              </div>

              <div class="col-md-6">
                <base-input
                  type="tel"
                  maxlength="10"
                  label="Cost *"
                  placeholder="Cost"
                  v-model="cost"
                  @keyup="numeric_cost"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <base-input
                  type="tel"
                  label="Game Count*"
                  maxlength="5"
                  @keyup="onlyNumeric"
                  placeholder="Game Count"
                  v-model="game_count"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <label>Pass Type</label>
                <select
                  v-model="environment_type"
                  class="location form-control"
                  style="width:100%; color:white !important;"
                >
                  <option
                    style="color:black !important;"
                    v-for="env in environmentTypes"
                    v-bind:key="env"
                    >{{ env.envType }}</option
                  >
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Event Type</label>
                <select
                  v-model="event_type"
                  class="location form-control"
                  style="width:100%; color:white !important;"
                >
                  <option
                    style="color:black !important;"
                    v-for="type in eventTypes"
                    v-bind:key="type"
                    :value="type._id"
                  >{{ type.value }}</option
                  >
                </select>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12">
                <label>Pass Description</label>
                <textarea
                  class="form-control"
                  style="padding: inherit; line-height:inherit;"
                  type="text"
                  rows="4"
                  label="Pass Description"
                  placeholder="Information about this pass"
                  v-model="description"
                >
                </textarea>
              </div>
            </div>

            <div class="row" style="margin:5px">
              <div class="col-md-6">
                <base-button
                  v-if="!isEdit"
                  native-type="submit"
                  type="primary"
                  @click="AddEve()"
                  class="btn-fill"
                  :disabled="loading"
                  >Save</base-button
                >
              </div>

              <div
                style="display: flex; flex-direction: row; justify-content:flex-end;"
                class="col-md-6"
              >
                <base-button
                  v-if="isEdit"
                  native-type="submit"
                  type="primary"
                  @click="UpdateEve()"
                  class="btn-fill"
                  :disabled="loading"
                  >Update</base-button
                >
                <base-button
                  v-if="isEdit && bookingCounts"
                  native-type="submit"
                  type="primary"
                  style="
                    border-radius: 25px;
                    background: #cc0000;
                  "
                  @click="DeletePass()"
                  class="btn-danger ml"
                  :disabled="loading"
                >
                  Delete
                </base-button>
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>
<script>

import { ImageUpload, BaseCheckbox, BaseRadio } from "src/components/index";
import { image } from "vee-validate/dist/rules";

export default {
  components: {
    ImageUpload,
    BaseRadio,
    BaseCheckbox
  },
  data() {
    return {
      bookingCounts: 0,
      active_status: true,
      pass_name: "",
      environment_type: "",
      event_type: "Game",
      cost: "",
      game_count: "",
      description: "",
      image: null,
      isEdit: false,
      loading: false,
      imageUploaded: false,
      environmentTypes: [],
      eventTypes: [{_id: 'Game', value: 'Game'}, {_id: 'LunchTimeGame', value: 'Lunch Time Game'}, {_id: 'Gym', value: 'Gym'}, {_id: 'Tournament', value: 'Tournament'}, {_id: 'Social', value: 'Social'}, {_id: 'Rackets', value: 'Rackets'}, {_id: 'Paddles', value: 'Paddles'}, {_id: 'Pickleball', value: 'Pickleball'}]
    };
  },

  async mounted() {
    debugger;
    console.log(this.$route.query.id);
    var id = this.$route.query.id;

    let environmentApiResponse = await this.$apiService.getCall(
      "environment/get-environments"
    );
    this.environmentTypes = environmentApiResponse.apidata.Data || [];
    this.environmentTypes.push({_id: '', envType: 'Rental'})

    if (id == -1) {
      this.isEdit = false;
    } else {
      this.isEdit = true;
      let pass = await this.$apiService.getCall("pass/passbyId/" + id);

      this.bookingCounts = pass.apidata.Data.bookingCounts;
      this.active_status = pass.apidata.Data.pass.active_status;
      this.pass_name = pass.apidata.Data.pass.name;
      this.environment_type = pass.apidata.Data.pass.environment_type;
      this.cost = pass.apidata.Data.pass.cost;
      this.game_count = pass.apidata.Data.pass.game_count;
      this.description = pass.apidata.Data.pass.description;
      this.event_type = pass.apidata.Data.pass.event_type;
    }
  },
  methods: {
    async UpdateEve() {
      debugger;

      var id = this.$route.query.id;
      if (!this.pass_name && !this.cost && !this.game_count) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }
      if (!this.pass_name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }
      if (!this.cost) {
        this.$apiService.notify("Cost is mandatory.");
        return;
      }
      if (!this.game_count) {
        this.$apiService.notify("Game Count is mandatory.");
        return;
      }
      if (!this.environment_type) {
        this.$apiService.notify("Pass type is mandatory.");
        return;
      }
      this.loading = true;

      var PassData = {
        name: this.pass_name,
        game_count: this.game_count,
        cost: this.cost,
        environment_type: this.environment_type,
        description: this.description,
        event_type: this.event_type
      };

      var update_pas = await this.$apiService.postCall(
        "pass/pass-update/" + id,
        PassData
      );
      console.log(update_pas);

      this.$apiService.notify("Pass has been updated.");
      this.$router.push("/passes/list");
    },
    async AddEve() {
      debugger;

      if (!this.pass_name && !this.cost && !this.game_count) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }
      if (!this.game_count) {
        this.$apiService.notify("Game Count is mandatory.");
        return;
      }
      if (!this.pass_name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }
      if (!this.cost) {
        this.$apiService.notify("Cost is mandatory.");
        return;
      }
      if (!this.environment_type) {
        this.$apiService.notify("Pass type is mandatory.");
        return;
      }

      this.loading = true;

      var add_pass = await this.$apiService.postCall("pass/add-pass", {
        name: this.pass_name,
        game_count: this.game_count,
        cost: this.cost,
        environment_type: this.environment_type,
        description: this.description,
        event_type: this.event_type
      });
      console.log(add_pass);
      this.loading = false;
      this.$apiService.notify("Pass has been added.", { duration: 2000 });
      this.$router.push("/passes/list");
    },
    async DeletePass() {
      debugger;
      const id = this.$route.query.id;
      const del_pas = await this.$apiService.postCall(
        "pass/pass-updatestatus/" + id,
        {
          active_status: false
        }
      );
      this.$apiService.notify("Pass has been deleted.");
      this.$router.push("/passes/list");
    },
    onlyNumeric() {
      this.game_count = this.game_count.replace(/[^0-9]/g, "");
    },
    numeric_cost() {
      this.cost = this.cost.replace(/[^0-9]/g, "");
    }
  }
};
</script>
<style>
.location {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  color: white;
}
form label {
  font-weight: 600;
}
.my-override {
  padding: inherit;
  line-height: inherit;
  border: revert;
  border-radius: 0.4285rem;
  border-color: #2b3553;
}
.coordinate {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 5px;
  font-size: 14px;
  border-radius: 5px;
  /* width: 100%; */
  color: white;
}
.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 9px;
  left: 19px;
  content: " ";
  display: block;
  background: #e14eca;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 15px;
  margin: 10px 0 0;
}

.radio-item input[type="radio"] {
  display: none;
}

.radio-item label {
  color: white;
  font-weight: 600;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid white;
  background-color: transparent;
}
</style>
